module.exports = __webpack_public_path__ + "img/DE00500.3ba9a508.png";